import { render, staticRenderFns } from "./GoverningBoardMembers.vue?vue&type=template&id=699a776c"
import script from "./GoverningBoardMembers.vue?vue&type=script&lang=js"
export * from "./GoverningBoardMembers.vue?vue&type=script&lang=js"
import style0 from "./GoverningBoardMembers.vue?vue&type=style&index=0&id=699a776c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports